module.exports = __webpack_public_path__ + "static/media/performance-1.385ee63a.jpg";